/**
 * @generated SignedSource<<62e8fba85206a08dac9ca8aa183e86fe>>
 * @relayHash d2bbf68684b92b2347afe2f0881877ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 09f92630e485923f6df517190e2dc48c050f35d914ca1d4cf53bf24f11d362b3

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type LevelUpSettingsQuery$variables = {
  cloudId: string;
  projectKey: string;
  siteAri: string;
};
export type LevelUpSettingsQuery$data = {
  readonly codeInJira: {
    readonly " $fragmentSpreads": FragmentRefs<"ConfigurationSection_codeInJira">;
  };
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"ConfigurationSection_jira">;
  };
  readonly jira_projectByIdOrKey: {
    readonly created: AGG$DateTime | null | undefined;
    readonly projectStyle: JiraProjectStyle | null | undefined;
    readonly projectType: JiraProjectType | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"AutomationsSection" | "ConfigurationSection_project">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ConfigurationSection_github">;
};
export type LevelUpSettingsQuery = {
  response: LevelUpSettingsQuery$data;
  variables: LevelUpSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteAri"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "created"
},
v4 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v5 = {
  "kind": "ScalarField",
  "name": "projectStyle"
},
v6 = [
  (v1/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "status"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LevelUpSettingsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v2/*: any*/),
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "jira_projectByIdOrKey",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "AutomationsSection"
            },
            {
              "kind": "FragmentSpread",
              "name": "ConfigurationSection_project"
            }
          ]
        },
        "action": "THROW",
        "path": "jira_projectByIdOrKey"
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v6/*: any*/),
          "concreteType": "CodeInJira",
          "kind": "LinkedField",
          "name": "codeInJira",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ConfigurationSection_codeInJira"
            }
          ]
        },
        "action": "THROW",
        "path": "codeInJira"
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ConfigurationSection_jira"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      },
      {
        "kind": "FragmentSpread",
        "name": "ConfigurationSection_github"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LevelUpSettingsQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "key"
          },
          (v7/*: any*/)
        ]
      },
      {
        "args": (v6/*: any*/),
        "concreteType": "CodeInJira",
        "kind": "LinkedField",
        "name": "codeInJira",
        "plural": false,
        "selections": [
          {
            "concreteType": "CodeInJiraUserConfiguration",
            "kind": "LinkedField",
            "name": "userConfiguration",
            "plural": false,
            "selections": [
              {
                "concreteType": "CodeInJiraBitbucketWorkspace",
                "kind": "LinkedField",
                "name": "ownedBitbucketWorkspaces",
                "plural": true,
                "selections": [
                  (v8/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsQuery",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "appId",
                    "value": "bitbucket"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "JiraAppConfigState",
                "kind": "LinkedField",
                "name": "configState",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraConfigStateConnection",
                    "kind": "LinkedField",
                    "name": "config",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraConfigState",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "appId"
                          },
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "siteAri"
              },
              {
                "kind": "Literal",
                "name": "providerTypes",
                "value": [
                  "DEV_INFO"
                ]
              }
            ],
            "concreteType": "DevOpsProviders",
            "kind": "LinkedField",
            "name": "providers",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevOpsDevInfoProvider",
                "kind": "LinkedField",
                "name": "devInfoProviders",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  {
                    "args": (v6/*: any*/),
                    "concreteType": "JiraAppConfigState",
                    "kind": "LinkedField",
                    "name": "configState",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraConfigStateConnection",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraConfigState",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  },
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "09f92630e485923f6df517190e2dc48c050f35d914ca1d4cf53bf24f11d362b3",
    "metadata": {},
    "name": "LevelUpSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "32aa38b9e2ca377c100b4f77f623a631";

export default node;
